<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            入库单号：<span v-if="formData.inNo"
                           style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.inNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 制单</span>
            <span v-else-if="formData.stat==1" class="information">制单</span>
            <span v-else-if="formData.stat==2" class="information">审核</span>
            <span v-else-if="formData.stat==99" class="information">作废</span>
            <span v-else class="information"></span>

          </div>

          <div class="fr">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="this.formData.stat!=2&&formData.stat!=99&&partsInSave"
                       @click="saveData">保存
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="this.formData.id!=null&&this.formData.stat!=2&&formData.stat!=99&&((partsInCheck&&!currentIsSite)||(partsInCheck&&currentIsSite&&formData.siteId==currentSiteData.id&&formData.billType==11))"
                       @click="showCloseDialog=true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-delete"
                       v-if="this.formData.id!=null&&this.formData.stat!=2&&formData.stat!=99&&partsInCancel"
                       @click="showCloseDialog=true;type='作废'">作废
            </el-button>
          </div>
        </div>


        <!-- 基本信息 -->
        <dix style="overflow-y: scroll!important;
    height: 100vh!important; ">
          <div class="d-cont edit-mce-box">
            <div class="d-item">
              <div class="title first"><b>基本信息</b></div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    入库类型
                  </th>
                  <td v-if="formData.stat!=2&&formData.stat!=99&&!currentIsSite">
                    <el-form-item>
                      <el-select v-model="formData.inType" @change="warehouseClear"  clearable>
                        <el-option label="仓库入库" :value="1"/>
                        <el-option label="网点仓入库" :value="2"/>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td v-else>
                    <span v-if="formData.inType==1">仓库入库</span>
                    <span v-else-if="formData.inType==2">网点库入库</span>
                    <span v-else></span>
                  </td>


                  <th>
                    <em class="f-red">*</em>
                    产品类型
                  </th>
                  <td v-if="formData.stat!=2&&formData.stat!=99&&!currentIsSite">
                    <el-form-item>
                      <el-select v-model="formData.itemType"
                                 @change="warehouseClear"
                                 clearable>
                        <el-option label="配件入库" :value="1"/>
                        <el-option v-if="!currentIsSite" label="产品入库" :value="2"/>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td v-else>
                    <span v-if="formData.itemType==1">配件入库</span>
                    <span v-if="formData.itemType==2">产品入库</span>
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    单据类型
                  </th>
                  <td v-if="this.formData.stat!=2&&formData.stat!=99&&!currentIsSite">
                    <el-form-item>
                      <el-select v-model="formData.billType"  clearable>
                        <el-option v-if="!currentIsSite" label="普通入库" :value="0"/>
                        <!--                        <el-option label="申请单入库" :value="1"/>-->
                        <!--                        <el-option label="返厂入库" :value="2"/>-->
                        <!--                        <el-option label="调拨入库" :value="3"/>-->
                        <el-option v-if="!currentIsSite" label="采购入库" :value="4"/>
                        <el-option v-if="!currentIsSite" label="更换配件" :value="5"/>
                        <el-option v-if="!currentIsSite" label="其他入库" :value="9"/>
                        <el-option v-if="!currentIsSite" label="帐务调整" :value="10"/>
                        <el-option label="盘盈入库" :value="11"/>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td v-else>
                    <span v-if="formData.billType==0">普通入库</span>
                    <span v-else-if="formData.billType==1">申请单入库</span>
                    <span v-else-if="formData.billType==2">返厂入库</span>
                    <span v-else-if="formData.billType==3">调拨入库</span>
                    <span v-else-if="formData.billType==4">采购入库</span>
                    <span v-else-if="formData.billType==5">更换配件</span>
                    <span v-else-if="formData.billType==9">其他入库</span>
                    <span v-else-if="formData.billType==10">帐务调整</span>
                    <span v-else-if="formData.billType==11">盘盈入库</span>
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    网点名称
                  </th>
                  <td v-if="formData.stat!=2 && formData.stat!=99 && !currentIsSite">
                    <el-input type="text" :disabled="formData.inType!=2"
                              autocomplete="off"
                              v-model="formData.siteName"
                              :readonly="true">
                      <i slot="suffix" class="el-input__icon el-icon-search"
                         @click="showSitePopFunc"></i>
                    </el-input>
                    {{ this.formData.stat == 2 ? this.formData.inWarehouseName : '' }}
                  </td>
                  <td v-else>{{ this.formData.siteName }}</td>


                </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    入库仓
                  </th>
                  <td v-if="this.formData.stat!=2&&formData.stat!=99">
                    <el-select v-model="formData.inWarehouseId"  @focus="warehouseClick" clearable>
                      <el-option v-for='item in warehouseList' :label="item.warehouseName" :value="item.id"/>
                    </el-select>

                  </td>
                  <td v-else>
                    {{ formData.inWarehouseName }}
                  </td>
                  <th>
                    总数量
                  </th>
                  <td>{{ formData.qty }}</td>
                  <th>
                    总金额
                  </th>
                  <td v-if="isSite">*</td>
                  <td v-else>{{ formData.amount }}</td>
                </tr>
                <tr>
                  <th>工单号</th>
                  <td>{{ formData.orderNo }}</td>

                  <th>配件申请单</th>
                  <td>{{ formData.partsApplyNo }}</td>

                  <th>配件返厂单</th>
                  <td>{{ formData.partsReturnNo }}</td><th>调拨单</th>
                  <td>{{ formData.whtowhNo }}</td>
                </tr>

                <tr>
                  <th>创建人</th>
                  <td>{{ formData.createBy }}</td>
                  <th>创建时间</th>
                  <td>{{ formData.createTime }}</td>
                  <th>审核人</th>
                  <td>{{ formData.checkBy }}</td>
                  <th>审核时间</th>
                  <td>{{ formData.checkDate }}</td>
                </tr>

                <tr>
                  <th>备注</th>
                  <td v-if="this.formData.stat!=2&&formData.stat!=99" colspan="7">
                    <el-input type="text"
                              maxlength="100"
                              autocomplete="off"
                              v-model="formData.remark"
                              clearable/>
                  </td>
                  <td colspan="7" v-else>{{ formData.remark }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
                <div class="title first"><b>入库明细</b></div>
                <div class="item-button" style="margin-top: 8px;">
                  <el-button type="primary" class="button-sty btn_zdy" @click="$refs.excelUpload.show()">
                    <i class="el-icon-plus"></i>
                    导入明细
                  </el-button>&nbsp;
                  <el-button type="primary" class="button-sty btn_zdy" v-if="this.formData.stat!=2&&formData.stat!=99"
                             @click="showPreconditionDialog=true"
                  >
                    <i class="el-icon-plus"></i>
                    添加明细
                  </el-button>&nbsp;
                  <el-button v-if="this.formData.stat!=2&&formData.stat!=99"
                             type="primary" class="button-sty btn_zdy" @click="deleteData">
                    <i class="el-icon-delete"></i>
                    批量删除
                  </el-button>
                </div>
              </div>
              <div>
                <vxe-table
                  style="margin-top: 5px;"
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  show-overflow
                  @checkbox-change="selectChangeEvent"
                  @checkbox-all="selectChangeEvent"
                  height="160" :column-config="{ resizable: true }"
                  :data="formData.spPartsInLineDTOList"
                >
                  <vxe-column type="checkbox" width="40"/>
                  <vxe-column field="partsCode" title="配件编码" width="200"></vxe-column>
                  <vxe-column field="partsName" title="配件名称" width="200"></vxe-column>
                  <vxe-column field="qty" title="数量" width="130">
                    <template #default="{row}">
                      <vxe-input v-if="formData.stat!=2&&formData.stat!=99" size="small" v-model="row.qty" type="number"
                                 min="1"
                                 :clearable="false"></vxe-input>
                      <span v-else>{{ row.qty }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="price" title="单价" width="130">
                    <template #default="{row}">
                      <span v-if="isSite">*</span>
                      <span v-else>{{row.price}}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="amount" title="金额" width="130">
                    <template #default="{row}">
                      <span v-if="isSite">*</span>
                      <span v-else>{{ row.qty * row.price }}</span>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>

          </div>
        </dix>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

    <sitePop v-if="showSitePop"
             @commit="siteCommit"
             :visiable.sync="showSitePop"
             multi="true"/>


    <parts-checkbox-common-dialog v-if="showPreconditionDialog"
                                  @confirm="commitSelectedRow"
                                  :visiable.sync="showPreconditionDialog"
                                  :param="{
                                    excludePartsIds: this.formData.spPartsInLineDTOList.map(item => item.partsId),
                                    saleStat: 1,
                                    warehouseId: this.formData.inWarehouseId
                                  }"
                                  multi="true"
    />

    <closeDialog v-if="showCloseDialog"
                 :dataId="formData.id"
                 :inNo="formData.inNo"
                 :type="type"
                 :visiable.sync="showCloseDialog"
                 multi="true"
                 @goBackIndex="goBackIndex"
    />
    <excel-upload
      ref="excelUpload"
      title="明细批量导入"
      :url="api.spPartsInHeader.importLineUrl"
      temp-url="/admin/sys-file/local/file/spPartsOutLine.xlsx"
      @refreshDataList="importLineData"
    ></excel-upload>
  </div>
</template>

<script>
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import partsInboundDialog from '@/views/dialogCommon/partsInboundDialog.vue';
import closeDialog from "./auditOrCloseDialog.vue";
import {mapGetters} from "vuex";
import {editPageMixins, siteMixins} from "@/mixins/tabChang";
import PartsCheckboxCommonDialog from "@/views/dialogCommon/partsCheckboxCommonDialog.vue";
import store from "@/store";
import ExcelUpload from "@/components/upload/excel.vue";

export default {
  mixins: [siteMixins, editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {ExcelUpload, PartsCheckboxCommonDialog, closeDialog, orderPop, sitePop, partsInboundDialog},
  data() {
    return {
      isSite: false,

      //权限
      // partsInSave:false,
      //partsInCheck:false,
      //partsInCancel:false,

      showAuditDialog: false,
      showCloseDialog: false,
      showSitePop: false,
      showWarehousePop: false,
      showPreconditionDialog: false,
      type: null,
      warehouseList: [],
      formData: {
        id: null,
        remark: null,
        inNo: null,  // 入库单号:前缀"I"+年月日+6位流水
        inType: null,  // 入库类型：1仓库入库;2网点仓入库
        itemType: 1,  // 产品类型：1配件入库;2产品入库
        billType: 0,  // 单据类型：0普通入库;1申请单入库;2返厂入库;3调拨入库;4采购入库;5;更换配件;9;其他入库;10帐务调整;11盘盈入库
        inWarehouseId: null,  // 入库仓id:关联bas_warehouse.id
        stat: 0,  // 状态：1制单;2审核;99做废
        qty: 0,  // 总数量
        amount: 0,  // 总金额
        siteId: 0,  // 网点ID,关联sn_user.id;inType=2时,此值非空
        checkDate: null,  // 审核时间
        checkBy: null,  // 审核人
        partsApplyId: 0,  // 配件申请单ID，关联sp_parts_apply_header.id
        partsReturnId: 0,  // 配件返厂单ID，关联sp_parts_return_header.id
        whtowhId: 0,  // 调拨单ID，关联sp_whtowh_header.id
        orderId: 0,  // 工单ID，关联so_order.id
        spPartsInLineDTOList: [],

        orderNo: null,
        partsApplyNo: null,
        partsReturnNo: null,
        whtowhNo: null,
        inWarehouseName: null,
        siteName: null
      },

      show3: false,

      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    }

  },
  created() {
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.partsInSave = this.permissions["partsInSave"]; //新增保存
    this.partsInCheck = this.permissions["partsInCheck"]; //审核
    this.partsInCancel = this.permissions["partsInCancel"]; //作废
  },
  mounted() {
    this.getData()
  },
  watch: {
    'formData.spPartsInLineDTOList': {
      handler(n) {
        if (n != null && n.length > 0) {
          let allQty = 0
          let allAmount = 0
          n.forEach(item => {
            allQty += Number(item.qty)
            allAmount += Number(item.qty) * Number(item.price)
          })
          this.formData.amount = Number(allAmount).toFixed(2)
          this.formData.qty = allQty
        } else {
          this.formData.amount = 0
          this.formData.qty = 0
        }
      },
      deep: true
    },
  },
  methods: {
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.formData.inType = 2
      this.formData.billType = 11
      this.loadWarehouse()
    },

    importLineData(data) {
      console.log('导入明细', data)
      this.$mask.open()
      this.$http.post(api.spPartsInHeader.loadLineInvQtyUrl, {
        spPartsInLineDTOList: data,
        outWarehouseId: this.formData.inWarehouseId
      }).then(res => {
        data = res.data.data
        this.$mask.close()
        if (!this.formData.spPartsInLineDTOList || this.formData.spPartsInLineDTOList.length == 0) {
          this.formData.spPartsInLineDTOList = data
        } else {
          this.formData.spPartsInLineDTOList.forEach(item => {
            data.forEach(item1 => {
              if (item1.partsId == item.partsId) {
                item.qty = Number(item.qty) + Number(item1.qty)
              }
            })
          })
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    // 仓库清空
    warehouseClear() {
      this.warehouseList = []
      this.formData.inWarehouseId = null
      this.formData.inWarehouseName = null
      this.formData.siteName = null
      this.formData.siteId = null
      this.formData.spPartsInLineDTOList = []
    },

    // 仓库加载
    loadWarehouse() {
      this.$http({
        url: api.spPartsInHeader.getInWarehouseUrl,
        method: 'post',
        data: {
          type: this.formData.inType,
          itemType: this.formData.itemType,
          siteId: this.formData.siteId,
        }
      }).then(res => {
        console.log(res.data.data, '仓库')
        this.warehouseList = res.data.data
      })
    },

    warehouseClick() {
      if (this.formData.inType == 1) {
        this.loadWarehouse()
      } else if (this.formData.inType == 2) {
        if (!this.formData.siteId) {
          this.$message.warning('请先选中网点')
        } else {
          this.loadWarehouse()
        }
      } else {
        this.$message.warning('请先选择入库类型')
      }
    },


    deleteData() {
      let selectedData = this.selectedData
      if (selectedData == null || selectedData.length == 0) {
        this.$message.warning('请先选中数据')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          let spPartsInLineDTOList = this.formData.spPartsInLineDTOList;
          selectedData.forEach(item => {
            spPartsInLineDTOList = spPartsInLineDTOList.filter(item1 => item1.id != item.id)
          })
          this.formData.spPartsInLineDTOList = spPartsInLineDTOList
        })
      }

    },

    // 复选框勾选
    selectChangeEvent(data) {
      this.selectedData = data.records
    },


    // 添加明细
    commitSelectedRow(data) {
      console.log('添加明细', data)
      data.forEach(item => {
        this.formData.spPartsInLineDTOList.push({
          isNew: true,
          id: -new Date().getTime() + Math.floor(Math.random() * 100),
          partsId: item.id,
          partsCode: item.partsCode,
          partsName: item.partsName,
          qty: 1,
          price: item.sitePrice,
          amount: item.sitePrice
        })
      })
      console.log(this.formData.spPartsInLineDTOList)
    },


    // 仓库弹框选中
    warehouseCommit(data) {
      console.log('选中的仓库', data)
      this.formData.inWarehouseId = data.warehouseId
      this.formData.inWarehouseName = data.warehouseName
    },


    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的网点', data)
      this.formData.siteId = data.id
      this.formData.siteName = data.name
      this.warehouseList = []
      this.formData.inWarehouseId = null
      this.formData.inWarehouseName = null
      this.formData.spPartsInLineDTOList = []
      this.loadWarehouse()
    },


    showSitePopFunc() {
      if (this.formData.inType == 2) {
        this.showSitePop = true
      }
    },

    // 抽屉关闭
    closeD() {
      this.showAuditDialog = false
      this.showCloseDialog = false
    },


    saveData() {
      const rules = {
        amount: [{required: true, type: 'number', max: 999999.99, min: 0, prop: '总金额'}],
        spPartsInLineDTOList: [{
          required: true, prop: '明细', type: 'list', rules: {
            qty: [{prop: '明细数量', required: true, type: 'number'}],
            // amount: [{prop: '单条明细金额', required: true, type: 'number', max: 999999.99}],
          }
        }],
      }

      if (this.formData.spPartsInLineDTOList == null || this.formData.spPartsInLineDTOList.length === 0) {
        this.$message.warning('请添加明细')
        return
      }

      this.$validate(this.formData, rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          this.formData.spPartsInLineDTOList.forEach(item => {
            item.amount = Number(item.qty) * Number(item.price)
          })
          this.$http({
            url: api.spPartsInHeader.saveOrUpdateUrl,
            method: 'post',
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$message.success("保存成功！");
            this.goBackIndex()
            this.$mask.close()

          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          })
        });
      })


    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.spPartsInHeader.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          if (this.formData.stat != 2) {
            this.loadWarehouse()
          }
        })
      } else {
        this.enabled = true;
      }
    },


  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}


// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}


// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 8vw !important;
}

#containt .table-detail tbody tr td {
  width: 12vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
</style>
